import { AxiosResponse } from "axios";
import axiosProxyHttpClient from "@/axios-proxy-http-client";
import { RequestConfig } from "@/interfaces/http/request-config";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon payments service
 */
export abstract class FalconService {
  /**
   * Makes request to getMyPayments falcon webservice method
   * @param alias Request alias
   * @param request Request data
   */
  static request<A, B>(alias: string, request: A): Promise<AxiosResponse<B>> {
    return axiosProxyHttpClient.post<B>("", request, {
      requestAlias: alias
    } as RequestConfig);
  }
}
